import { openConfirmModal } from '@mantine/modals';
import { Text } from '@mantine/core';
import { useCallback } from 'react';

export default function useConfirmAction() {
  return useCallback(({ title, onConfirmAction }) => {
    openConfirmModal({
      title,
      children: <Text size="sm">此操作無法復原，你確定要繼續嗎？</Text>,
      labels: { confirm: '是，我確定', cancel: '取消' },
      confirmProps: { color: 'red' },
      onConfirm: onConfirmAction,
    });
  }, []);
}
